export const ADD_TEACHER_REQUEST = 'ADD_TEACHER_REQUEST';
export const ADD_TEACHER_SUCCESS = 'ADD_TEACHER_SUCCESS';
export const ADD_TEACHER_FAIL = 'ADD_TEACHER_FAIL';

export const GET_TEACHERS_REQUEST = 'GET_TEACHERS_REQUEST';
export const GET_TEACHERS_SUCCESS = 'GET_TEACHERS_SUCCESS';
export const GET_TEACHERS_FAIL = 'GET_TEACHERS_FAIL';

export const UPDATE_TEACHER_REQUEST = 'UPDATE_TEACHER_REQUEST';
export const UPDATE_TEACHER_SUCCESS = 'UPDATE_TEACHER_SUCCESS';
export const UPDATE_TEACHER_FAIL = 'UPDATE_TEACHER_FAIL';

export const DELETE_TEACHER_REQUEST = 'DELETE_TEACHER_REQUEST';
export const DELETE_TEACHER_SUCCESS = 'DELETE_TEACHER_SUCCESS';
export const DELETE_TEACHER_FAIL = 'DELETE_TEACHER_FAIL';

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 